import { MappingItemsSelectionNode } from './mapping-items-selection-node.interface';

/**
 * REV-20899: print-preview-side bundle of mapping trees used to live-recompute
 * super-table row values from the latest AR. Built by `SuperTableMapper.buildLiveTrees`
 * from a reclass-applied clone of `finStatements` so each FLI node carries the aggregated
 * `closingReClass` / `openingReClass` (including phantom reclasses accounts).
 *
 * Lives here rather than beside the mapper that consumes it so both the notes-display
 * mapper and the builder can reference it without an import cycle.
 */
export interface ISuperTablePrintPreviewLiveTrees {
    balance: MappingItemsSelectionNode | null;
    income: MappingItemsSelectionNode | null;
}
